<template>
    <div v-if="listStyle.common" class="minisite-list-08" :class="'template-' + listStyle.templateId">
        <div class="list-search" v-show="getShowedComponent && getShowedComponent.search">
            <search-component
                @search="search"
                :settings="data.search"
                v-model="searchWord"
                :search-style="listStyle.searchStyle"></search-component>
        </div>
        <div class="list-content">
            <div
                v-for="(item, itemIndex) in filterData"
                :key="item.id"
                class="minisite-list-item"
                :style="{ width: listStyle.common.width + '%' }">
                <click-action
                    :type="data.type"
                    class="main-item-content"
                    :style="[getCommonStyle, { flexDirection: listStyle.listStyle.flexDirection.direction }]"
                    :data="item.clickAction"
                    :key="item.id">
                    <div
                        v-show="getShowedComponent.button && getTopButtonStatus"
                        class="button-icon-container"
                        :style="[getButtonMargin, getPadding(listStyle.common.textPadding)]">
                        <basic-button-image-collection
                            :data="item.button"
                            @collection-status-change="
                                collectionStatusChange({
                                    item,
                                    collectionId: `${_pageId}_${data.id}_${item.id}`,
                                    showedStatus: getShowedComponent
                                })
                            "
                            :item-id="`${_pageId}_${data.id}_${item.id}`"
                            :collection-style="listStyle.collectionStyle"
                            :button-style="listStyle.buttonStyle"></basic-button-image-collection>
                    </div>
                    <div
                        v-if="getShowedComponent.image"
                        class="left-container"
                        :style="[getImageStyle, { height: blockHeight }, getImageMargin]">
                        <div class="image-container" :style="[{ width: listStyle.imageStyle.width + '%' }]">
                            <basic-image
                                :data="item.image"
                                :image-style="listStyle.imageStyle"
                                :image-title-style="listStyle.imageTitleFontStyle"></basic-image>
                            <div
                                v-show="
                                    listStyle.collectionStyle.listPosition === 'image' && getShowedComponent.collection
                                "
                                class="image-collection"
                                :style="{ backgroundColor: listStyle.collectionStyle.backgroundColor }">
                                <collection
                                    :data="item.button"
                                    @collection-status-change="
                                        collectionStatusChange({
                                            item,
                                            collectionId: `${_pageId}_${data.id}_${item.id}`,
                                            showedStatus: getShowedComponent
                                        })
                                    "
                                    :item-id="`${_pageId}_${data.id}_${item.id}`"
                                    :collection-style="listStyle.collectionStyle"></collection>
                            </div>
                        </div>
                    </div>
                    <div class="button-icon-container" :style="getPadding(listStyle.common.textPadding)">
                        <div v-show="getShowedComponent.title" class="title-container" :style="getTitleMargin">
                            <basic-text :data="item.title" :font-style="listStyle.titleFontStyle"></basic-text>
                        </div>
                        <div v-show="getShowedComponent.desc" class="desc-container">
                            <basic-text :data="item.desc" :font-style="listStyle.descFontStyle"></basic-text>
                        </div>
                        <div
                            v-show="getShowedComponent.button && getBottomButtonStatus"
                            class="button-container"
                            :style="getButtonMargin">
                            <basic-button-image-collection
                                :data="item.button"
                                @collection-status-change="
                                    collectionStatusChange({
                                        item,
                                        collectionId: `${_pageId}_${data.id}_${item.id}`,
                                        showedStatus: getShowedComponent
                                    })
                                "
                                :item-id="`${_pageId}_${data.id}_${item.id}`"
                                :collection-style="listStyle.collectionStyle"
                                :button-style="listStyle.buttonStyle"></basic-button-image-collection>
                        </div>
                    </div>
                </click-action>
                <div
                    class="divide-line"
                    :style="getDivideStyle"
                    v-show="getShowedComponent.divideLine && itemIndex < filterData.length - 1">
                </div>
            </div>
            <div class="minisite-list-item" :style="{ width: listStyle.common.width + '%' }"></div>
            <div class="minisite-list-item" :style="{ width: listStyle.common.width + '%' }"></div>
            <div class="minisite-list-item" :style="{ width: listStyle.common.width + '%' }"></div>
            <div class="minisite-list-item" :style="{ width: listStyle.common.width + '%' }"></div>
        </div>
    </div>
</template>

<script>
    import listMixin from "./list.mixin"

    export default {
        name: "ListTemplate08",
        mixins: [listMixin],
        props: {
            data: {}
        },
        data() {
            return {
                listStyle: {},
                blockHeight: "initial"
            }
        },
        computed: {
            getBottomButtonStatus() {
                return (
                    (this.listStyle.listStyle.flexDirection.direction === "column-reverse" &&
                        this.listStyle.buttonStyle.buttonToImagePosition === "top") ||
                    this.listStyle.listStyle.flexDirection.direction === "column"
                )
            },
            getTopButtonStatus() {
                return (
                    this.listStyle.listStyle.flexDirection.direction === "column-reverse" &&
                    this.listStyle.buttonStyle.buttonToImagePosition === "bottom"
                )
            },
            getImageMargin() {
                return {
                    marginTop:
                        this.listStyle.listStyle.flexDirection.direction === "column-reverse" &&
                        (this.getShowedComponent.desc || this.listStyle.buttonStyle.buttonToImagePosition === "top")
                            ? "8px"
                            : "0"
                }
            },
            getButtonMargin() {
                return {
                    marginTop: this.getShowedComponent.desc || this.getTopButtonStatus ? "8px" : "0"
                }
            },
            getTitleMargin() {
                return {
                    marginTop:
                        (this.listStyle.listStyle.flexDirection.direction === "column" &&
                            !this.listStyle.imageStyle.show) ||
                        this.listStyle.listStyle.flexDirection.direction === "column-reverse"
                            ? -this.listStyle.titleFontStyle.padding.top + "px"
                            : "0"
                }
            }
        },
        mounted() {}
    }
</script>

<style lang="less" scoped>
    .minisite-list-08 {
        .list-content {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: space-between;
            //align-items: flex-start;
        }

        .minisite-list-item {
            display: flex;
            flex-direction: column;
        }

        .main-item-content {
            display: flex;
            flex-direction: column;
            flex-grow: 1;
            overflow: hidden;
        }

        .title-container,
        .desc-container {
            width: 100%;
            max-width: 100%;
        }

        .left-container {
            flex-grow: 0;
            flex-shrink: 0;
            width: 100%;
            display: flex;
            justify-content: center;
            position: relative;

            .image-container {
                display: flex;
                align-items: center;
                justify-content: center;

                .image-collection {
                    width: 32px;
                    height: 32px;
                    border-radius: 0 0 4px 4px;
                    position: absolute;
                    top: 0px;
                    right: 8px;
                }
            }
        }

        .button-container {
            width: 100%;
        }

        .right-container {
            width: 100%;
        }

        .right-icon {
            margin-left: 10px;
            flex-shrink: 0;

            .icon-image {
                max-width: 50px;
            }
        }

        .button-icon-container {
            width: 100%;
        }
    }
</style>
